import { css } from 'styled-components';
import { FormItemStatus } from '../Form';
export var makeTextField = function makeTextField(_ref) {
  var theme = _ref.theme,
      hasLeftIcon = _ref.hasLeftIcon,
      hasClearIcon = _ref.hasClearIcon;
  return css(["background-color:", ";border:1px solid ", ";border-radius:8px;width:100%;padding-left:", ";padding-right:", ";color:", ";", " font-weight:400;font-family:", ";caret-color:", ";appearance:none;box-sizing:border-box;transition:all 300ms;&:disabled{background-color:", ";border-color:", ";color:", ";}&:focus{outline:none;border-color:", ";}"], theme.colors.base.white, theme.colors.grey.base, hasLeftIcon ? '48px' : theme.space.s + "px", hasClearIcon ? '48px' : theme.space.s + "px", theme.colors.text.base, theme.typography.variants.body, theme.typography.fontFamily, theme.colors.primary.base, theme.colors.grey.light, theme.colors.grey.light, theme.colors.grey.dark, theme.colors.base.black);
};
export function getValidationStatusColor(validationStatus, theme) {
  var _validationStatusColo;

  var validationStatusColorMap = (_validationStatusColo = {}, _validationStatusColo[FormItemStatus.ERROR] = theme.colors.red.dark, _validationStatusColo[FormItemStatus.SUCCESS] = theme.colors.green.dark, _validationStatusColo);
  return validationStatusColorMap[validationStatus];
}
export var makeTextFieldValidationStatus = function makeTextFieldValidationStatus(_ref2) {
  var theme = _ref2.theme,
      validationStatus = _ref2.validationStatus;

  if (!validationStatus) {
    return;
  }

  var validationStatusColor = getValidationStatusColor(validationStatus, theme);
  return "\n    color: " + validationStatusColor + ";\n    border-color: " + validationStatusColor + ";\n    caret-color: " + validationStatusColor + ";\n    &:focus {\n      box-shadow: 0 0 0 1px " + validationStatusColor + ";\n      border-color: " + validationStatusColor + ";\n    }\n  ";
};
export var makeDefaultField = css(["", " ", ""], makeTextField, makeTextFieldValidationStatus);